import { render, staticRenderFns } from "./member_service_agreement.vue?vue&type=template&id=a6bf1fc8&scoped=true&"
import script from "./member_service_agreement.vue?vue&type=script&lang=js&"
export * from "./member_service_agreement.vue?vue&type=script&lang=js&"
import style0 from "./member_service_agreement.vue?vue&type=style&index=0&id=a6bf1fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf1fc8",
  null
  
)

export default component.exports